import ArticleReader from '@nile/rmm/src/modules/knowledge-base/components/ArticleSearchSheet/ArticleReader';
import React, { useState } from 'react';
import { DisplayText, TextStyle } from '@superops/ui-design-system';
import ReactMarkdown from 'react-markdown';
import { getTranslatedText } from '@nile/components';
import { useIntl } from 'react-intl';

const KbRelevantArticle = ({ suggestions }) => {
  const [selectedArticle, setSelectedArticle] = useState(
    suggestions?.aiGeneratedArticle?.title
  );
  const [selectedArticleId, setSelectedArticleId] = useState(null);
  const intl = useIntl();
  return (
    <div className="fx fhp kb-relevant-article overflow-hidden">
      <div className="left overflow-scroll">
        <div className="title mb5">
          <TextStyle weight="Bold" variation="strong">
            {getTranslatedText(intl, 'ai.ticket.deflection.monica.suggestion')}
          </TextStyle>
        </div>
        <div
          className={`link link-block ${
            selectedArticle === suggestions?.aiGeneratedArticle?.title
              ? 'selected'
              : ''
          }`}
          onClick={() => {
            setSelectedArticle(suggestions?.aiGeneratedArticle?.title);
            setSelectedArticleId(null);
          }}
        >
          <TextStyle weight="Regular">
            {suggestions?.aiGeneratedArticle?.title}
          </TextStyle>
        </div>
        <div className="title mt20 mb5">
          <TextStyle weight="Bold" variation="strong">
            {getTranslatedText(intl, 'ai.ticket.deflection.relevant.articles')}
          </TextStyle>
        </div>
        {suggestions?.citations?.map((article) => (
          <div
            className={`link link-block ${
              selectedArticle === article.title ? 'selected' : ''
            }`}
            onClick={() => {
              setSelectedArticle(article.title);
              setSelectedArticleId({ id: article.id });
            }}
          >
            <TextStyle weight="Regular">{article.title}</TextStyle>
          </div>
        ))}
      </div>
      <div className="right overflow-scroll">
        {selectedArticleId ? (
          <ArticleReader selectedArticle={selectedArticleId} hideToolBar />
        ) : (
          <>
            <div className="mb6">
              <DisplayText element="h2" size="ExtraLarge" weight="SemiBold">
                {suggestions?.aiGeneratedArticle?.title}
              </DisplayText>
            </div>
            <ReactMarkdown>
              {suggestions?.aiGeneratedArticle?.content}
            </ReactMarkdown>
          </>
        )}
      </div>
    </div>
  );
};

export default KbRelevantArticle;
